import React, { useEffect, useState } from "react";
import { fetchBrighterScoreApi } from "../../store/dashboard/BrighterScoreActions";
import { useDispatch, useSelector } from "react-redux";
import PopupModal from "../../common/PopupModal";
import { brighterScoreMockData, dentistSpecialityCode } from "../../store/MockData/BrighterScoreMockData";
import BrighterRecommendationsYes from "../../assets/images/brighterRecommendationsYes.svg";
import BrighterRecommendationsNo from "../../assets/images/brighterRecommendationsNo.svg";
import "./BrighterScorePopup.scss";
import checkMarkCircleIcon from "../../assets/Icons/checkMarkCircleIcon.png";
import affordabilityGraph from "../../assets/images/affordabilityGraph.png";
import chartGraph from "../../assets/images/chartGradient.png";
import { Link, useLocation } from "react-router-dom";
import Technology from "../practice/practice-highlights/Technology";
import Amenities from "../practice/practice-highlights/Amenities";
import GeneralCertification from "../providers/experience/GeneralCertification";
import ProviderEducation from "../providers/experience/ProviderEducation";

const BrighterScorePopup = ({
  openPopupModal,
  closePopupCallBack = () => {},
  streetAddress,
  selectedProvidersDetails,
  carrier,
}) => {
  const [isOpen, setOpen] = useState(true);
  const [openTechnologyPopup, setOpenTechnologyPopup] = useState(false);
  const [openAminitiesPopup, setOpenAminitiesPopup] = useState(false);
  const [openCertificationPopup, setOpenCertificationPopup] = useState(false);
  const [openEducationPopup, setOpenEducationPopup] = useState(false);
  const [brighterScoreDetails, setBrighterScoreDetails] = useState();
  const [showError, setShowError] = useState(false);

  const location = useLocation();
  const locationHeaderData = location.pathname.split("/");
  const practiceId = locationHeaderData[2];

  const dispatch = useDispatch();

  const { brighterScoreData, brighterScoreErrorMsg } = useSelector(
    (state) => state.brighterScoreData
  );

  useEffect(() => {
    setOpen(openPopupModal);
  }, [isOpen]);

  useEffect(() => {
    if (brighterScoreData.length > 0) {
      const carrierName = carrier.slice(1).toLowerCase();
      const filteredBrighterScoreData = brighterScoreData.filter(
        (item) =>
          item?.brighterScores[0]?.carrier.slice(1).toLowerCase() ===
          carrierName
      );
      setBrighterScoreDetails(filteredBrighterScoreData[0]);
    }
  }, [brighterScoreData]);

  useEffect(() => {
    if (brighterScoreErrorMsg) {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 2000);
    }
  }, [brighterScoreErrorMsg]);

  const getBarHeight = (count) => {
    const maxHeight = 135;
    if (count >= 25) return maxHeight;
    return (count / 25) * maxHeight;
  };

  const renderItems = (items) => {
    if (!items) return null;

    if (!Array.isArray(items) && items.name) {
      return <span>{items.name}</span>;
    }

    if (Array.isArray(items)) {
      return items.map((item, index) => <span key={index}>{item.name}</span>);
    }
    return null;
  };

  const recommendationRates = () => {
    const yesVotes =
      brighterScoreDetails?.brighterScores[0]?.brighterRecommendCount;
    const totalVotes =
      parseInt(
        brighterScoreDetails?.brighterScores[0]?.brighterRecommendCount
      ) +
      parseInt(
        brighterScoreDetails?.brighterScores[0]?.brighterNotRecommendCount
      );
    return Math.round((yesVotes / totalVotes) * 100);
  };

  const RenderGeneralCertificationPopup = () => {
    return (
      <>
        {openCertificationPopup && (
          <GeneralCertification
            openCertificationPopup={openCertificationPopup}
            providerId={selectedProvidersDetails?.displayId}
            onlyPopup={true}
            closePopupCallback={(res) => {
              if (res) {
                dispatch(
                  fetchBrighterScoreApi({
                    practiceId,
                    providersId: selectedProvidersDetails?.displayId,
                  })
                );
              }
              setOpenCertificationPopup(false);
            }}
            onSaveTotalCallback={() => {}}
          />
        )}
      </>
    );
  };

  const RenderProviderEducationPopup = () => {
    return (
      <>
        {openEducationPopup && (
          <ProviderEducation
            openEducationPopup={openEducationPopup}
            onlyPopup={true}
            providerId={selectedProvidersDetails?.displayId}
            closePopupCallback={(res) => {
              if (res) {
                dispatch(
                  fetchBrighterScoreApi({
                    practiceId,
                    providersId: selectedProvidersDetails?.displayId,
                  })
                );
              }
              setOpenEducationPopup(false);
            }}
            onSaveTotalCallback={() => {}}
          />
        )}
      </>
    );
  };

  const RenderTechnologyPopup = () => {
    return (
      <>
        {openTechnologyPopup && (
          <Technology
            openTechPopup={openTechnologyPopup}
            onlyPopup={true}
            closePopupCallback={() => {
              console.log("called Technology");
              // if (res) {
              dispatch(
                fetchBrighterScoreApi({
                  practiceId,
                  providersId: selectedProvidersDetails?.displayId,
                })
              );
              // }
              setOpenTechnologyPopup(false);
            }}
            onSaveTotalCallback={() => {}}
          />
        )}
      </>
    );
  };

  const RenderAminities = () => {
    return (
      <>
        {openAminitiesPopup && (
          <Amenities
            closePopupCallback={() => {
              console.log("called aminities");
              dispatch(
                fetchBrighterScoreApi({
                  practiceId,
                  providersId: selectedProvidersDetails?.displayId,
                })
              );
              setOpenAminitiesPopup(false);
            }}
            onlyPopup={true}
            openAminitiesPopup={openAminitiesPopup}
            brighterScoreAmenitiesData={
              brighterScoreDetails?.brighterScores[0]?.Amenities
            }
            onSaveTotalCallback={() => {}}
          />
        )}
      </>
    );
  };

  const RenderBrighterScoreOverview = () => {
    if (
      !brighterScoreMockData ||
      !brighterScoreData ||
      !brighterScoreDetails?.brighterScores ||
      !brighterScoreDetails?.brighterScores[0]
    )
      return null;
    return (
      <>
        <h1>
          {brighterScoreMockData?.heading} : {brighterScoreDetails?.brighterScores[0]?.carrier}
        </h1>
        <p>
          {brighterScoreMockData?.note}
          <span>{brighterScoreMockData?.noteText}</span>
        </p>

        {brighterScoreDetails?.brighterScores[0]?.carrier !== "Cigna - DHMO" ? <div className="brighterScoreDetails">
          <div className="brighterScorePoints">
            <div className="brighterScoreOverallScore">
              <span>{`${brighterScoreDetails?.brighterScores[0]?.overallScore}`}</span>
              /10
            </div>
            <div className="brighterScoreText">
              {brighterScoreMockData?.brighterScoreText}
            </div>
          </div>
          <div className="brighterScoreData">
            <div className="brighterScoreNameAddress">
              {selectedProvidersDetails?.name} - <span>
                {streetAddress?.street1}, {streetAddress?.street2},
                {streetAddress?.city}, {streetAddress?.state},
                {streetAddress?.postalCode}
              </span>
            </div>
            <div className="historyExperienceAffordabilityScores">
              <span
                className="scorePoints"
                style={{
                  marginLeft: "4px",
                }}
              >{`${brighterScoreDetails?.brighterScores[0]?.professionalHistoryScore}`}</span>
              /10 <span className="professionalHistoryText">
                {brighterScoreMockData?.professionalHistoryText}
              </span>
              <span
                className="scorePoints"
                style={{
                  marginLeft: "8px",
                }}
              >{`${brighterScoreDetails?.brighterScores[0]?.patientExperienceScore}`}</span>
              /10 <span className="patientExperienceText">
                {brighterScoreMockData?.patientExperienceText}
              </span>
              <span
                className="scorePoints"
                style={{
                  marginLeft: "8px",
                }}
              >{`${brighterScoreDetails?.brighterScores[0]?.affordabilityScore}`}</span>
              /10 <span className="affordabilityText">
                {brighterScoreMockData?.affordabilityText}
              </span>
            </div>
          </div>
        </div> : null}

        <div className="brighterGraphGradientWrapper">
          <img src={chartGraph} className="graphGradient" />
          <ul className="list-inline color-chart">
            <li>
              <p></p>
            </li>
            <li>
              <p></p>
            </li>
            <li>
              <p></p>
            </li>
            <li>
              <p></p>
            </li>
            <li>
              <p></p>
            </li>
          </ul>
          <ul className="number-line left-padding-zero">
            <li className="ends">0.0</li>
            <li>1.0</li>
            <li>2.0</li>
            <li>3.0</li>
            <li>4.0</li>
            <li>5.0</li>
            <li>6.0</li>
            <li>7.0</li>
            <li>8.0</li>
            <li>9.0</li>
          </ul>
        </div>

        <div className="score-table-container">
          <h2>{brighterScoreMockData?.scoreTableHeading}</h2>
          <p>{brighterScoreMockData?.scoreTableText}</p>
          <div className="scoreTable">
            <div className="gradeRow">
              <div className="grade excellent">
                {brighterScoreMockData?.scoreTableGrade1}
              </div>
              <div className="gradeNote">
                {brighterScoreMockData?.scoreTableGradeNote1}
              </div>
            </div>

            <div className="gradeRow">
              <div className="grade veryGood">
                {brighterScoreMockData?.scoreTableGrade2}
              </div>
              <div className="gradeNote">
                {brighterScoreMockData?.scoreTableGradeNote2}
              </div>
            </div>

            <div className="gradeRow">
              <div className="grade fair">
                {brighterScoreMockData?.scoreTableGrade3}
              </div>
              <div className="gradeNote">
                {brighterScoreMockData?.scoreTableGradeNote3}
              </div>
            </div>

            <div className="gradeRow">
              <div className="grade average">
                {brighterScoreMockData?.scoreTableGrade4}
              </div>
              <div className="gradeNote">
                {brighterScoreMockData?.scoreTableGradeNote4}
              </div>
            </div>

            <div className="gradeRow">
              <div className="grade improvement">
                {brighterScoreMockData?.scoreTableGrade5}
              </div>
              <div className="gradeNote">
                {brighterScoreMockData?.scoreTableGradeNote5}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const RenderProfessionalHistory = () => {
    if (
      !brighterScoreMockData ||
      !brighterScoreData ||
      !brighterScoreDetails?.brighterScores ||
      !brighterScoreDetails?.brighterScores[0]
    )
      return null;
    return (
      <div>
        <h3 className="brighterScoreComponentHeading">
          {brighterScoreMockData?.brighterScoreComponentHeading}
        </h3>

        <div className="patientHistoryWrapper">
          <div className="patientHistoryHeader">
            <h4>
              <span>{brighterScoreMockData?.professionalHistoryText}</span>
              {`${brighterScoreDetails?.brighterScores[0]?.professionalHistoryScore} / 10`}
            </h4>
          </div>
          <div className="patientHistoryContent">
            <p>{brighterScoreMockData?.professionalHistoryNote}</p>

            <div className="professionalHistoryKeyElements">
              {brighterScoreDetails?.brighterScores[0]?.yearsOfExperience && (
                <div className="professionalHistoryList">
                  <img
                    alt=""
                    src={checkMarkCircleIcon}
                    width="45px"
                    height="45px"
                    className="checkMarkCircle"
                  />
                  <span className="itemText" onClick={() => {}}>
                    {brighterScoreDetails?.brighterScores[0]?.yearsOfExperience}{" "}
                    {brighterScoreMockData?.yearsOfExperienceText}
                  </span>
                </div>
              )}

              {brighterScoreDetails?.brighterScores[0]?.cleanLicense ===
              true ? (
                <div className="professionalHistoryList">
                  <img
                    alt=""
                    src={checkMarkCircleIcon}
                    width="45px"
                    height="45px"
                    className="checkMarkCircle"
                  />
                  <span className="itemText">
                    {brighterScoreMockData?.noLicenseText}
                  </span>
                </div>
              ) : (
                <div className="professionalHistoryList">
                  <span className="minus">&times;</span>
                  <span className="itemText">
                    {brighterScoreMockData?.hasLicenseText}
                  </span>
                </div>
              )}

              {(brighterScoreDetails?.brighterScores[0]?.schools?.name?.length >
                0 ||
                (brighterScoreDetails?.brighterScores[0]?.schools &&
                  brighterScoreDetails?.brighterScores[0]?.schools?.length >
                    0)) && (
                <div className="professionalHistoryList">
                  <img
                    alt=""
                    src={checkMarkCircleIcon}
                    width="45px"
                    height="45px"
                    className="checkMarkCircle"
                  />
                  <span className="listItems">
                    {renderItems(
                      brighterScoreDetails?.brighterScores[0]?.schools
                    )}
                  </span>
                </div>
              )}

              {(brighterScoreDetails?.brighterScores[0]?.certifications?.name
                ?.length > 0 ||
                (brighterScoreDetails?.brighterScores[0]?.certifications &&
                  brighterScoreDetails?.brighterScores[0]?.certifications
                    ?.length > 0)) && (
                <div className="professionalHistoryList">
                  <img
                    alt=""
                    src={checkMarkCircleIcon}
                    width="45px"
                    height="45px"
                    className="checkMarkCircle"
                  />
                  <span className="itemText">
                    {renderItems(
                      brighterScoreDetails?.brighterScores[0]?.certifications
                    )}
                  </span>
                </div>
              )}

              <div
                className="professionalHistoryList"
                onClick={() => {
                  setOpenEducationPopup(true);
                }}
              >
                <span className="plusCircleListIcon">+</span>
                <span className="listItemLink">
                  {brighterScoreMockData?.addEducationText}
                </span>
              </div>

              <div
                className="professionalHistoryList"
                onClick={() => setOpenCertificationPopup(true)}
              >
                <span className="plusCircleListIcon">+</span>
                <span className="listItemLink">
                  {brighterScoreMockData?.addCertificationsText}
                </span>
              </div>
            </div>
            <div className="profilePageText">
              {brighterScoreMockData?.reviewNote}
              <Link
                style={{
                  marginLeft: "4px",
                }}
                to={`/provider/${selectedProvidersDetails?.displayId}/profile-information/info?fromPractice=${practiceId}`}
              >
                profile page
              </Link>
              .
            </div>
          </div>
        </div>
      </div>
    );
  };

  const RenderPatientExperience = () => {
    if (
      !brighterScoreMockData ||
      !brighterScoreData ||
      !brighterScoreDetails?.brighterScores ||
      !brighterScoreDetails?.brighterScores[0]
    )
      return null;
    return (
      <div className="patientExperienceWrapper">
        <div className="patientExperienceHeader">
          <h4>
            <span>{brighterScoreMockData?.patientExperience}</span>
            {brighterScoreDetails?.brighterScores[0]?.totalReviewCount == 0
              ? "N/A"
              : `${brighterScoreDetails?.brighterScores[0]?.patientExperienceScore} / 10`}
          </h4>
        </div>
        <div className="patientExperienceContent">
          <p>{brighterScoreMockData?.patientExperienceNote}</p>
          <h4 className="textCenter">
            <span>{brighterScoreMockData?.reviewQuestion1}</span>
          </h4>
          <p className="brighterText">
            {brighterScoreMockData?.patientExperienceBrighterText}
          </p>

          <div className="reviewSection">
            <div className="countContent">
              <h5>{brighterScoreMockData?.totalReviewText}</h5>
              <p className="reviewCount">
                {brighterScoreDetails?.brighterScores[0]?.totalReviewCount}
              </p>
            </div>
            <div className="chartWrapper">
              {brighterScoreDetails?.brighterScores[0]?.totalReviewCount < 1 ? (
                <p>{brighterScoreMockData?.patientExperienceScoreNote}</p>
              ) : (
                <div className="chartBarWrapper">
                  <div className="labelLinesContainer">
                    <div className="axisLabels leftAxis">
                      <span className="leftLabel">
                        {brighterScoreMockData?.barLeftLabel1}
                      </span>
                      <span className="leftLabel">
                        {brighterScoreMockData?.barLeftLabel2}
                      </span>
                      <span className="leftLabel">
                        {brighterScoreMockData?.barLeftLabel3}
                      </span>
                      <span className="leftLabel">
                        {brighterScoreMockData?.barLeftLabel4}
                      </span>
                      <div className="verticalLine leftLine"></div>
                    </div>

                    <div className="barsContainer">
                      <div
                        className="bar"
                        style={{
                          height: `${getBarHeight(
                            brighterScoreDetails?.brighterScores[0]
                              ?.totalReviewCount
                          )}px`,
                        }}
                      ></div>
                      <div className="horizontalLine"></div>
                    </div>

                    <div className="axisLabels rightAxis">
                      <span className="rightLabel">
                        {brighterScoreMockData?.barRightLabel1}
                      </span>
                      <span className="rightLabel">
                        {brighterScoreMockData?.barRightLabel2}
                      </span>
                      <span className="rightLabel">
                        {brighterScoreMockData?.barRightLabel3}
                      </span>
                      <span className="rightLabel">
                        {brighterScoreMockData?.barRightLabel4}
                      </span>
                      <div className="verticalLine rightLine"></div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <h4 className="textCenter">
            <span>{brighterScoreMockData?.brighterRecommendationHeading}</span>
          </h4>
          <p className="brighterText">
            {brighterScoreMockData?.brighterRecommendationText}
          </p>

          <div className="reviewSection">
            <div className="countContent">
              <h5>{brighterScoreMockData?.recommendationRateText}</h5>
              <p className="reviewCount">
                {brighterScoreDetails?.brighterScores[0]
                  ?.brighterRecommendCount == 0
                  ? "N/A"
                  : recommendationRates() + `%`}
              </p>
            </div>
            <div className="brighterRecommendationsWrapper">
              <div className="brighterRecommendationsContent">
                {brighterScoreMockData?.brighterRecommendations}
                <img src={BrighterRecommendationsYes} width={20} height={20} />
                <span className="reviewsCounts">
                  {
                    brighterScoreDetails?.brighterScores[0]
                      ?.brighterRecommendCount
                  }
                </span>
                <span className="yesNoText">Yes</span>
                <img src={BrighterRecommendationsNo} width={20} height={20} />
                <span className="reviewsCounts">
                  {
                    brighterScoreDetails?.brighterScores[0]
                      ?.brighterNotRecommendCount
                  }
                </span>
                <span className="yesNoText">No</span>
              </div>
              <div className="brighterRecommendationsText">
                {brighterScoreDetails?.brighterScores[0]?.brighterTotalCount ===
                0 ? (
                  <p>
                    <b>0 Verified review</b> <span>collected by Brighter</span>
                  </p>
                ) : (
                  <p>
                    <Link
                      to={`/practice/${practiceId}/profile-information/reviews`}
                    >
                      Click here
                    </Link>
                    <b>
                      to see your{" "}
                      {
                        brighterScoreDetails?.brighterScores[0]
                          ?.brighterTotalCount
                      }
                      {" "}Verified reviews
                    </b>
                    <span> collected by Brighter</span>
                  </p>
                )}
              </div>
            </div>
          </div>

          <h4 className="textCenter">
            <span>
              {brighterScoreMockData?.advancedTechnologiesAmenitiesText}
            </span>
          </h4>
          <p className="brighterText">
            {brighterScoreMockData?.affordabilityContentNote}
          </p>

          <div className="technologyAmenitiesWrapper">
            <div className="technologyAmenitiesContent">
              <div className="technologyAmenitiesHeader">
                <div>Technologies</div>
                <button
                  className="btn edit-button updateBtn"
                  onClick={() => setOpenTechnologyPopup(true)}
                >
                  Update
                </button>
              </div>
              <div className="technologyAmenitiesBody">
                <ul>
                  {brighterScoreDetails?.brighterScores[0]?.technologies
                    ?.length > 0 &&
                    brighterScoreDetails?.brighterScores[0]?.technologies.map(
                      (item, index) => {
                        return <li key={index}>{item?.name}</li>;
                      }
                    )}
                </ul>
              </div>
            </div>
            <div className="technologyAmenitiesContent">
              <div className="technologyAmenitiesHeader">
                <div>Amenities</div>
                <button
                  className="btn edit-button updateBtn"
                  onClick={() => setOpenAminitiesPopup(true)}
                >
                  Update
                </button>
              </div>
              <div className="technologyAmenitiesBody">
                <ul>
                  {brighterScoreDetails?.brighterScores[0]?.amenities?.length >
                    0 &&
                    brighterScoreDetails?.brighterScores[0]?.amenities.map(
                      (item, index) => {
                        return <li key={index}>{item.name}</li>;
                      }
                    )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const RenderAffordability = () => {
    if (
      !brighterScoreMockData ||
      !brighterScoreData ||
      !brighterScoreDetails?.brighterScores ||
      !brighterScoreDetails?.brighterScores[0]
    )
      return null;
    return (
      <div className="affordabilityWrapper">
        <div className="affordabilityHeader">
          <h4>
            <span>{brighterScoreMockData?.affordabilityText} :</span>
            {`${brighterScoreDetails?.brighterScores[0]?.affordabilityScore} / 10`}
          </h4>
        </div>
        <div className="affordabilityContent">
          <p>{brighterScoreMockData?.affordabilityContentText}</p>
          <div className="contractedFeesWrapper">
            <div className="contractedFeesText">
              {/* {brighterScoreMockData?.contractedFeesText} */}
              Your Cigna contracted fees vs. other {dentistSpecialityCode[brighterScoreDetails?.brighterScores[0]?.specialtyCode]} in your area
            </div>
            <div className="graphWrapper">
              <img src={affordabilityGraph} className="affordabilityGraph" />
              <ul className="left-padding-zero" id="price-line">
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
              </ul>
            </div>
          </div>
          <div className="contactText">
            {brighterScoreMockData?.contactText}
          </div>
        </div>
      </div>
    );
  };

  const RenderBrighterScorePopupDetails = () => {
    if (
      !brighterScoreMockData ||
      !brighterScoreData ||
      !brighterScoreDetails?.brighterScores ||
      !brighterScoreDetails?.brighterScores[0]
    )
      return null;
    return (
      <div className="brighterScorePopupDetailsWrapper">
        {RenderBrighterScoreOverview()}
        {RenderProfessionalHistory()}
        {RenderPatientExperience()}
        {brighterScoreDetails?.brighterScores[0]?.carrier !== "Cigna - DHMO" && brighterScoreDetails?.brighterScores[0]?.carrier !== "Aetna - DMO" ? RenderAffordability() : null}
        <div className="footerNote">
          {brighterScoreMockData?.footerNote}
          <Link
            to={"/contactUs"}
          >
            contact us
          </Link>
          .
        </div>
      </div>
    );
  };

  const RenderBrighterScoreError = () => {
    if (!showError) return null;
    return (
      <div
        className="overlay-alert alert alert-danger alertTopPosition"
        role="alert"
      >
        {brighterScoreErrorMsg}
      </div>
    );
  };

  const RenderBrighterScorePopup = () => {
    return (
      <PopupModal
        key={brighterScoreData}
        isOpen={isOpen}
        customRender={RenderBrighterScorePopupDetails}
        onSave={() => {
          closePopupCallBack();
        }}
        onClose={() => {
          setOpen(!isOpen);
          closePopupCallBack();
        }}
        width="83%"
      />
    );
  };

  return (
    <div>
      {RenderBrighterScoreError()}
      {RenderBrighterScorePopup()}
      {RenderGeneralCertificationPopup()}
      {RenderProviderEducationPopup()}
      {RenderTechnologyPopup()}
      {RenderAminities()}
    </div>
  );
};

export default BrighterScorePopup;
